let minx = {
  data() {
    return {

    }
  },
  methods: {
    /**
     *
     * @param {*} tip 二次弹框的提示信息
     * @param {*} success_cb 成功的回调
     * @param {*} error_cb 失败的回调
     * @param {*} option 参数配置
     */
    showDialog(tip, success_cb, error_cb, option = {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }) {
      const html = `<div class="ept-second-comfirm-wapper">
        <p class="ept-second-comfirm-title"><img class="ept-second-comfirm-img" src="${require('@/assets/image/warning.png')}" alt="">注意</p>
        <div class="ept-second-comfirm-body">${tip}</div>
      </div>`;
      this.$confirm(html, '', {
        confirmButtonText: option.confirmButtonText,
        cancelButtonText: option.cancelButtonText,
        // type: 'warning'
        dangerouslyUseHTMLString: true,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: 'ept-second-comfirm-dialog'
      }).then(() => {
        success_cb && success_cb()
      })
          .catch(() => {
            error_cb && error_cb()
          });
    }
  }
}

export default minx;
